export default __webpack_public_path__ + "images/lock-2.453ab482676aa5fdf84646c3ff6cf23c.png";